import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@mui/material';

import { Block, Table } from '../CommonComponents';
import { useDispatch, useSelector } from '../../redux/hooks';
import {
    fetchPublishedOrders,
    selectOrderStatusCount,
    selectPublishedOrders
} from '../../redux/actions/orders';
import { getOrderDate } from '../../utils/order';
import { formatCities } from '../../utils/parsing';

export default function PublishedOrders() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const publishedOrders = useSelector(selectPublishedOrders());
    const orderStatusCount = useSelector(selectOrderStatusCount());
    const publishedCount = orderStatusCount.PUBLISHED;
    const title = typeof publishedCount === 'number'
        ? `Publicerade uppdrag (${publishedCount})`
        : 'Publicerade uppdrag';

    React.useEffect(() => {
        dispatch(fetchPublishedOrders());
    }, [dispatch]);

    return (
        <Block
            title={title}
            ActionComponent={(
                <Button
                    variant="outlined"
                    onClick={() => navigate('/orders')}
                >
                    Alla uppdrag
                </Button>
            )}
        >
            <Table
                name="dashboardPublishedOrders"
                columns={[{
                    name: 'Datum',
                    key: 'date',
                    getValue: getOrderDate
                }, {
                    name: 'Sträcka',
                    key: 'cities',
                    getValue: formatCities
                }, {
                    name: 'Totalvikt',
                    key: 'grossWeight',
                    type: 'kg' as 'kg'
                }, {
                    name: 'Riktpris',
                    key: 'listPrice',
                    type: 'currency' as 'currency'
                }, {
                    name: 'Anmäl senast',
                    key: 'expiresAt',
                    type: 'datetime' as 'datetime'
                }]}
                data={publishedOrders}
                onRowClick={({ id }: { id: number }) => navigate(`/orders/${id}`)}
                defaultOrderBy="date"
                emptyText="Ni har inga publicerade uppdrag"
            />
        </Block>
    );
}
